import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Row, Col, Card, Button, Container, Table } from "react-bootstrap";
import Nav from "./Navbar";
import Footer from "./Footer";
import { FaCheck } from "react-icons/fa";
import { Link } from "react-router-dom";
import { BASE_URL_API_TRANXT_UAT_API } from "../Utils/Constant";
import { basicauth } from "../Utils/Credentials";

const Pricing = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <Container fluid className="p-0">
      <div>
        {/* <div
          className="d-flex justify-content-center"
          style={{ background: "#fdca40" }}
        >
          <p className="p-2 m-0 text-center">
            Start with free trial of <b>SeoBix!</b>-boost your SEO
            game&nbsp;&nbsp;{" "}
            <Button size="sm" variant="success">
              Know More
            </Button>
          </p>
        </div> */}
        <Nav />
      </div>
      {/* start */}
      <div className=" p-0">
        <div className=" mt-3">
          <div className="row mx-md-0 mx-3 mt-sm-3">
            <div className="col-md-1"></div>
            <div className="col m-0 p-0">
              <h1
                style={{
                  // fontFamily: "'Playfair Display', serif",
                  fontSize: "2.5rem",
                }}
                className="mt-2 mb-3 text-center"
              >
                <b>Plans & Pricing</b>
              </h1>
              <div className="text-center my-4">
                <h4
                  className="font-weight-bold mb-4"
                  style={{ color: "#441752" }}
                >
                  🚀 Improve Your Rankings —{" "}
                  <span style={{ color: "#FC4100" }}>
                    Try Our Service Free for 3 Months!
                  </span>
                  , Limited Time Only!
                </h4>
                <Link
                  style={{ textDecoration: "none" }}
                  onClick={() =>
                    window.open("https://dashboard.seobix.com/", "_blank")
                  }
                >
                  <span
                    style={{
                      color: "#fff",
                      fontWeight: 500,
                      cursor: "pointer",
                      padding: "7px 12px",
                      border: "1px solid #007bff",
                      backgroundColor: "#007bff",
                      borderRadius: "6px",
                      fontSize: ".9rem",
                      textDecoration: "none",
                    }}
                  >
                    Get Started For Free
                  </span>
                </Link>
              </div>
              <Pricingcard />
              <Addonprice />
            </div>
            <div className="col-md-1"></div>
          </div>
        </div>
      </div>
      {/* end */}
      <div
        className="m-0 p-0"
        style={{
          overflow: "hidden",
          background:
            "linear-gradient(to right, rgb(175, 221, 255), rgb(255, 255, 255))",

          borderTopRightRadius: "2rem",
          borderTopLeftRadius: "2rem",
        }}
      >
        <Footer />
      </div>
    </Container>
  );
};
const toNumber = (val) => {
  if (val == null) return 0;
  if (typeof val === "number") return val;
  if (typeof val === "string") {
    const cleaned = val.replace(/[^0-9.]/g, "");
    const parsed = parseFloat(cleaned);
    return Number.isNaN(parsed) ? 0 : parsed;
  }
  return 0;
};

const formatMoney = (amount, currencyCode) =>
  new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: currencyCode,
    maximumFractionDigits: 2,
  }).format(amount);

const Pricingcard = () => {
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currency, setCurrency] = useState("USD");
  const [billingCycle, setBillingCycle] = useState("monthly"); // 👈 NEW
  const USD_TO_INR = 87;
  const { password, username } = basicauth;
  const base64Credentials = btoa(`${username}:${password}`);
  const GetPricingPlans = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Setting/GetPricingPlans`,
        {
          method: "POST",
          headers: {
            Authorization: `Basic ${base64Credentials}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({}),
        }
      );

      if (!response.ok) throw new Error("Failed to fetch SEO data.");

      const data = await response.json();

      if (data.status === "0" && data.data) {
        const sortedPlans = [...data.data].sort((a, b) => {
          if (a.identity === "4") return -1;
          if (b.identity === "4") return 1;
          return parseInt(a.identity) - parseInt(b.identity);
        });

        const formattedPlans = sortedPlans.map((plan) => ({
          name: plan.plan_name,
          priceUSD: toNumber(plan.amount),
          duration: plan.duration,
          description: plan.desc1,
          features1: plan.features1,
          features2: plan.features2,
          features3: plan.features3,
          features4: plan.features4,
          heading: plan.heading,
          desc2: plan.desc2,
          features: Array.isArray(plan.data)
            ? plan.data.map((feature) => ({
                text: feature.description,
                video: feature.video_url || null,
              }))
            : [],
          buttonText: "Start Now",
        }));

        setPlans(formattedPlans);
      } else {
        setPlans([]);
      }
    } catch (error) {
      console.error("Error fetching SEO data:", error);
      setPlans([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    GetPricingPlans();
  }, []);
  return (
    <>
      {loading ? (
        <div className="text-center my-5">
          <img src={require("../Images/loader.gif")} alt="seobix" />
        </div>
      ) : (
        <>
          {/* Switchers */}
          <div className="d-flex justify-content-center align-items-center gap-4 mb-4">
            {/* Currency Switcher */}
            <div className="d-flex align-items-center gap-2">
              <span className="fw-semibold">USD</span>
              <div className="form-check form-switch m-0">
                <input
                  className="form-check-input"
                  type="checkbox"
                  role="switch"
                  id="currencySwitch"
                  checked={currency === "INR"}
                  onChange={(e) =>
                    setCurrency(e.target.checked ? "INR" : "USD")
                  }
                />
                <label className="form-check-label" htmlFor="currencySwitch">
                  {currency}
                </label>
              </div>
              <span className="fw-semibold">INR</span>
            </div>

            {/* Billing Cycle Switcher */}
            <div className="d-flex align-items-center gap-2">
              <span className="fw-semibold">Monthly</span>
              <div className="form-check form-switch m-0">
                <input
                  className="form-check-input"
                  type="checkbox"
                  role="switch"
                  id="billingSwitch"
                  checked={billingCycle === "yearly"}
                  onChange={(e) =>
                    setBillingCycle(e.target.checked ? "yearly" : "monthly")
                  }
                />
                <label className="form-check-label" htmlFor="billingSwitch">
                  {billingCycle === "yearly" ? "Yearly" : "Monthly"}
                </label>
              </div>
              <span className="fw-semibold">Yearly</span>
            </div>
          </div>

          <Row className="justify-content-center mx-1">
            {plans.map((plan, index) => {
              let base = plan.priceUSD;

              if (billingCycle === "yearly") {
                base = base * 12;
              }

              const amount = currency === "USD" ? base : base * USD_TO_INR;
              const displayPrice = formatMoney(amount, currency);

              return (
                <Col key={index} md={6} lg={3} className="mb-4">
                  <Card className="shadow-sm h-100">
                    <Card.Body className="p-3">
                      <h5 className="mb-1">
                        <b>{plan.name}</b>
                      </h5>
                      <h3>
                        <b>{displayPrice}</b>/
                        <span style={{ fontSize: "1rem" }}>
                          {billingCycle === "yearly" ? "year" : plan.duration}
                        </span>
                      </h3>
                      <Link
                        onClick={() =>
                          window.open("https://dashboard.seobix.com/", "_blank")
                        }
                        style={{ textDecoration: "none", color: "#fff" }}
                      >
                        <Button className="mt-2 mb-2" style={{ width: "100%" }}>
                          {plan.buttonText}
                        </Button>
                      </Link>

                      <p className="text-muted mb-2 mt-3">
                        <b>{plan.description}</b>
                      </p>

                      {plan.features1 && (
                        <p>
                          <FaCheck style={{ color: "green" }} /> &nbsp;&nbsp;
                          {plan.features1}
                        </p>
                      )}
                      {plan.features2 && (
                        <p>
                          <FaCheck style={{ color: "green" }} /> &nbsp;&nbsp;
                          {plan.features2}
                        </p>
                      )}
                      {plan.features3 && (
                        <p>
                          <FaCheck style={{ color: "green" }} /> &nbsp;&nbsp;
                          {plan.features3}
                        </p>
                      )}
                      {plan.features4 && (
                        <p>
                          <FaCheck style={{ color: "green" }} /> &nbsp;&nbsp;
                          {plan.features4}
                        </p>
                      )}

                      {plan.heading && (
                        <h6>
                          <b>{plan.heading}</b>
                        </h6>
                      )}
                      {plan.desc2 && (
                        <p
                          className="text-muted mb-2 mt-3"
                          style={{ fontWeight: "500" }}
                        >
                          {plan.desc2}
                        </p>
                      )}
                    </Card.Body>
                  </Card>
                </Col>
              );
            })}
          </Row>
        </>
      )}
    </>
  );
};
const Addonprice = () => {
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(false);

  // 👇 new states
  const [currency, setCurrency] = useState("USD");
  const [billingCycle, setBillingCycle] = useState("monthly");
  const USD_TO_INR = 87;
  const { password, username } = basicauth;
  const base64Credentials = btoa(`${username}:${password}`);

  useEffect(() => {
    GetPricingPlansAddOn();
  }, []);

  const GetPricingPlansAddOn = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Setting/GetPricingPlansAddOn`,
        {
          method: "POST",
          headers: {
            Authorization: `Basic ${base64Credentials}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({}),
        }
      );

      if (!response.ok) throw new Error("Failed to fetch SEO data.");

      const data = await response.json();
      if (data.status === "0" && data.data) {
        const formattedPlans = data.data.flatMap((category) =>
          category.data.map((addon) => ({
            id: addon.id,
            heading: addon.heading2,
            description: addon.desc,
            // store as numbers
            basic: toNumber(addon.basic_desc),
            standard: toNumber(addon.standard_desc),
            premium: toNumber(addon.premium_desc),
          }))
        );
        setPlans(formattedPlans);
      } else {
        setPlans([]);
      }
    } catch (error) {
      console.error("Error fetching SEO data:", error);
    } finally {
      setLoading(false);
    }
  };

  // 🔄 Convert + Format based on currency & billing
  const getDisplayPrice = (amount) => {
    if (billingCycle === "yearly") amount = amount * 12; // yearly multiplier
    const final = currency === "USD" ? amount : amount * USD_TO_INR;
    return formatMoney(final, currency);
  };

  return (
    <>
      {loading ? (
        <div className="text-center my-5">
          <img src={require("../Images/loader.gif")} alt="seobix" />
        </div>
      ) : (
        <div>
          {/* Switchers */}
          <div className="d-flex justify-content-center align-items-center gap-4 mb-4">
            {/* Currency Switcher */}
            <div className="d-flex align-items-center gap-2">
              <span className="fw-semibold">USD</span>
              <div className="form-check form-switch m-0">
                <input
                  className="form-check-input"
                  type="checkbox"
                  role="switch"
                  id="currencySwitchAddon"
                  checked={currency === "INR"}
                  onChange={(e) =>
                    setCurrency(e.target.checked ? "INR" : "USD")
                  }
                />
                <label
                  className="form-check-label"
                  htmlFor="currencySwitchAddon"
                >
                  {currency}
                </label>
              </div>
              <span className="fw-semibold">INR</span>
            </div>

            {/* Billing Cycle Switcher */}
            <div className="d-flex align-items-center gap-2">
              <span className="fw-semibold">Monthly</span>
              <div className="form-check form-switch m-0">
                <input
                  className="form-check-input"
                  type="checkbox"
                  role="switch"
                  id="billingSwitchAddon"
                  checked={billingCycle === "yearly"}
                  onChange={(e) =>
                    setBillingCycle(e.target.checked ? "yearly" : "monthly")
                  }
                />
                <label
                  className="form-check-label"
                  htmlFor="billingSwitchAddon"
                >
                  {billingCycle === "yearly" ? "Yearly" : "Monthly"}
                </label>
              </div>
              <span className="fw-semibold">Yearly</span>
            </div>
          </div>

          <hr />
          <h2 className="mb-3">Addon Pricing</h2>

          <Table>
            <thead>
              <tr>
                <th style={{ width: "40%" }}>Feature</th>
                <th style={{ width: "20%" }}>Basic</th>
                <th style={{ width: "20%" }}>Standard</th>
                <th style={{ width: "20%" }}>Premium</th>
              </tr>
            </thead>
            <tbody>
              {plans.map((addon) => (
                <tr key={addon.id}>
                  <td>
                    <strong>{addon.heading}</strong>
                    <p>{addon.description}</p>
                  </td>
                  <td>
                    {getDisplayPrice(addon.basic)}/
                    {billingCycle === "yearly" ? "year" : "month"}
                    <br /> <br />
                    <Button
                      size="sm"
                      style={{
                        color: "green",
                        background: "#fff",
                        border: "1px solid green",
                      }}
                      onClick={() =>
                        window.open("https://dashboard.seobix.com/", "_blank")
                      }
                    >
                      Buy Now
                    </Button>
                  </td>
                  <td>
                    {getDisplayPrice(addon.standard)}/
                    {billingCycle === "yearly" ? "year" : "month"}
                    <br /> <br />
                    <Button
                      size="sm"
                      style={{
                        color: "green",
                        background: "#fff",
                        border: "1px solid green",
                      }}
                      onClick={() =>
                        window.open("https://dashboard.seobix.com/", "_blank")
                      }
                    >
                      Buy Now
                    </Button>
                  </td>
                  <td>
                    {getDisplayPrice(addon.premium)}/
                    {billingCycle === "yearly" ? "year" : "month"}
                    <br /> <br />
                    <Button
                      size="sm"
                      style={{
                        color: "green",
                        background: "#fff",
                        border: "1px solid green",
                      }}
                      onClick={() =>
                        window.open("https://dashboard.seobix.com/", "_blank")
                      }
                    >
                      Buy Now
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      )}
    </>
  );
};

export default Pricing;
